<template>
    <div class="radio-group">
        <p class="radio-group__label">{{ label }}</p>

        <div class="radio-group__wrap">
            <label
                class="radio-group__item"
                v-for="(item, index) in items"
                :key="item.value"
            >
                <input
                    class="radio-group__item-input"
                    type="radio"
                    :name="name"
                    :id="`${name}-${index}`"
                    :value="item.value"
                    :checked="item.value === value"
                    :disabled="disabled"
                    @input="onInput"
                    @change="onChange"
                >
                <span class="radio-group__item-label">
                    {{ item.label }}
                </span>
            </label>
        </div>

        <div class="radio-group__status" v-if="status">
            {{ status }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'radio-group',

    props: {
        name: {
            required: true,
            type: String,
        },
        label: {
            required: true,
            type: String,
        },
        items: {
            required: true,
            type: Array,
        },
        status: {
            required: false,
            type: String,
        },
        value: {
            required: false,
            type: String,
        },
        disabled: {
            required: false,
            type: Boolean,
        },
    },

    data() {
        return {
            hasFocus: false,
        };
    },

    computed: {
        hasValue() {
            return typeof this.value !== 'undefined' && this.value !== '';
        },
    },

    methods: {
        onInput(e) {
            this.$emit('input', e.target.value);
        },
        onChange(e) {
            this.$emit('change', e.target.value);
        },
    },
};
</script>
